import React, {Component, createRef} from "react";
import DataTable from './TableBase';
import { offerColumns } from './RecordCells';
import {withRouter} from "react-router-dom";
import Swal from "sweetalert2";
import {apiCall} from "../../helpers/MainHelper";
import withPermissions from "../WithPermissions";
import ReactDOMServer from "react-dom/server";
import ReactLoading from "react-loading";
import "../../screens/Offers/OfferManagement.css";
class OffersTable extends Component{

    constructor(props) {
        super(props);
        this.tableRef = createRef();
        this.state = {
            pending:true
        }

    }
    triggerFetch = (page = 1, size = 10, search = '') => {
        if (this.tableRef.current) {
            this.tableRef.current.fetchData(page, size, search);
        }
    };

    handleDelete = async (offerId) => {
        const result = await Swal.fire({
            title: 'Silmek istediğinize emin misiniz?',
            text: "Bu işlem geri alınamaz!",
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Evet, sil!',
            cancelButtonText: 'Hayır, iptal et',
            preConfirm: async () => {
                const confirmButton = Swal.getConfirmButton();
                const originalButtonText = confirmButton.innerHTML;
                confirmButton.disabled = true;
                confirmButton.innerHTML = ReactDOMServer.renderToString(<ReactLoading type="spin" width={'24px'} height={'24px'} color="#ffffff" />);

                try {
                    await apiCall('business/offers/delete/'+offerId,'delete',null);
                    await this.triggerFetch();
                    return true;
                } catch (error) {
                    return false;
                } finally {
                    confirmButton.innerHTML = originalButtonText;
                    confirmButton.disabled = false;
                }
            }
        });

        if (result.isConfirmed) {
            if (result.value) {
                Swal.fire(
                    'Silindi!',
                    'Teklif başarıyla silindi.',
                    'success'
                );
            } else {
                Swal.fire(
                    'Hata!',
                    'Silme işlemi başarısız oldu.',
                    'error'
                );
            }
        }
    }
    handleOfferDetail = (offerId) => {
        this.props.history.push(`/offer-detail/${offerId}`);
    }
    render() {
        const {pending} = this.state;
        const {userPermissions} = this.props;
        const userHasViewOfferPermission = userPermissions.includes('view offer');
        const userHasDeleteOfferPermission = userPermissions.includes('delete offer');
        const columns = offerColumns({ canView: userHasViewOfferPermission, canDelete: userHasDeleteOfferPermission, onView: row => this.handleOfferDetail(row.id), onDelete: row => this.handleDelete(row.id) });

        return (
            <DataTable
                ref={this.tableRef}
                dataEndpoint={"business/offers/all"}
                columns={columns}
                onRowClicked={userHasViewOfferPermission ? row => this.handleOfferDetail(row.id) : undefined}
                progressPending={pending}>
            </DataTable>
        )
    }

}
export default withPermissions(withRouter(OffersTable));
